class ReportDataController {
  constructor(loadingService, reportingService, $scope, $filter) {
    "ngInject";

    this.loadingService = loadingService;
    this.reportingService = reportingService;
    this.$scope = $scope;
    this.$filter = $filter;
    
    this.$scope.$on('reports:runReport', this.runReport.bind(this));
    this.$scope.$on('reports:reset', this.reset.bind(this));
  }

  reset(){
    this.reportData = [];
  }

  runReport(e, data) {
    if (!data.criteriaValidator()) {return;}

    this.loadingService.showLoading('reportData', 'Running Report ...');

    this.reportingService.runReport(data.action, data.criteriaParser())
      .then(response => {
        this.reportHeaders = response.data.headers;
        
        if (data.selector) {
          this.reportData = data.selector(response.data.data);
        }
        else {
          this.reportData = response.data.data;          
        }
        this.onReportRun({summary: response.data.summary, data: this.reportData});        
      })
      .finally(() => {
        this.loadingService.hideLoading('reportData');
      });
  }
}

export default ReportDataController;



// WEBPACK FOOTER //
// ./client/app/components/reports/reportData/reportData.controller.js